import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'grupo', namespaced: true })

export default mystore
